export default __webpack_public_path__ + "static/media/black.60e88aa6.jpg";